/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2022-03-02 09:37:28
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-10-15 20:25:11
 * @FilePath: \baishu_react_ui\src\components\BsyAlert\index.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from 'react'
import ReactDOM from 'react-dom'
import AlertList from './Staticize'
import {BsyUtils} from "../../utils/Utils";

const BsyAlert = props =>
    new Promise((fulfill) => { // 此处参数需用圆括号，否则 eslint 报错
        let holder
        let stopProp = (event) =>{
            event.stopPropagation()
        }
        let rootTokenClass = 'rootTokenCls'+ (new Date()).getTime()
        let CleanRootNode = (e)=>{
            // 当界面被点击时自动清理元素
            // e 为null，组件自己清理自己
            // 无法找到父级元素 rootTokenClass 说明点击了其他任意位置
            if(!e || !BsyUtils.closestClass(e.target,rootTokenClass)) {

                holder && holder.classList.remove("fadein");
                setTimeout(()=>{
                    holder && holder.removeEventListener('mouseup', stopProp, false);
                    // holder && ReactDOM.unmountComponentAtNode(holder)
                    holder && holder.remove();
                },60)
                document.removeEventListener('mouseup', CleanRootNode, false);
            }
        }
        if(document.getElementsByClassName("BsyAlert").length>0){
            document.getElementsByClassName("BsyAlert")[0].removeChild(document.getElementsByClassName("BsyAlert")[0].firstChild);
            holder = document.getElementsByClassName("BsyAlert")[0]
        }else{
            holder = document.createElement('div');
            holder.style.zIndex = window.FX.STATIC.zIndex++
            holder.style.position = 'fixed';
            holder.classList.add("BsyAlert");
            window.mode && holder.classList.add(window.mode);
            document.body.appendChild(holder)
        }

        let holderTo = document.createElement('div');
        holderTo.classList.add("alertContent");
        holder.classList.add('rootTokenClass');
        holder.onclick = (event) =>{
            event.stopPropagation()
        }
        holder.appendChild(holderTo)
        holder.classList.add("fadein");
  
        setTimeout(()=>{
            holder.classList.add("active");
        },30)
        // let timer = setTimeout(()=>{
        //     holder.removeChild(holderTo)
        //     ReactDOM.unmountComponentAtNode(holderTo)
        //     if(document.getElementsByClassName("alertImgCodeContent").length<=0){
        //         document.body.removeChild(holder)
        //         ReactDOM.unmountComponentAtNode(holder)
        //     }
        //     clearInterval(timer)
        // },3000)

        if(document.getElementsByClassName("alertContent").length>1){
            holder.removeChild(holderTo)
            // ReactDOM.unmountComponentAtNode(holderTo)
            // clearInterval(timer)
        }
        const newProps={...props,target:holderTo}
        newProps.onRemoveRoot = (event)=>{
            // event && event.stopPropagation();
            //自动清理
            CleanRootNode();

        }
        ReactDOM.render(
            <AlertList
                {...newProps}
            />,
            holderTo
        )
    }).catch(res => {
        console.error('BsyAlert',res);
    })

export default BsyAlert